import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/site";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Pillars } from "@/components/site/Pillars";
import { Coverage } from "@/components/site/Coverage";
import { Fleet } from "@/components/site/Fleet";
import { Proof } from "@/components/site/Proof";
import { FinalCta } from "@/components/site/FinalCta";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function Home() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/config`)
      .then((r) => setConfig(r.data))
      .catch(() => toast.error("Could not load booking options — please refresh"));
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#0b101b] text-[#f1f5f9]" data-testid="home-page">
      <Nav />
      <Hero config={config} />
      <Marquee />
      <Pillars />
      <Fleet config={config} />
      <Coverage />
      <Proof />
      <FinalCta />
      <SiteFooter />
    </div>
  );
}
